import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceRequestComponent } from 'src/app/components/service-request/service-request.component';
import { StandaloneContainerComponent } from 'src/app/components/standalone/standalone-container/standalone-container.component';
import { ServiceRequestMapComponent } from 'src/app/components/service-request-map/service-request.component-map';
import { Complaint2Component } from 'src/app/components/complaint-2/complaint-2.component';
import { ComplaintComponent } from 'src/app/components/complaint/complaint.component';

const routes: Routes = [
    {
        path: '', component: StandaloneContainerComponent,
        children: [
            { path: 'registrar-reclamo', component: Complaint2Component },
            { path: 'registrar-reclamov2', component: ComplaintComponent },
            { path: 'solicitar-servicio', component: ServiceRequestMapComponent },
            { path: 'solicitar-servicio-form', component: ServiceRequestComponent },
            {
                path: 'tienda',
                loadChildren: () => import('../virtual-store/virtual-store.module').then(m => m.VirtualStoreModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StandaloneRoutingModule { }
